import classNames from 'classnames';
import { PropsWithClassName } from 'lib-shared-types-utils';

import styles from './dixaLogo.module.scss';

/** Represents the Dixa logo with animation. */
export const DixaLogo = ({ className }: PropsWithClassName): JSX.Element => (
  <div
    className={classNames(styles.logo, className)}
    data-test-id="loader-logo"
  >
    <svg className={styles.l1} viewBox="0 0 90 96">
      <path d="M84.8 19.2C74.2.8 50.6-5.5 32.2 5.2L1.8 22.7c-1.7 1-2.3 3.1-1.3 4.8L26.9 73c.6 1 .9 2.1.9 3.2v18.9c0 .7.8 1.1 1.4.8l8.3-4.8 5.7-3.3 27.7-16C83.1 64.7 90 51.8 90 38.5c0-6.6-1.7-13.2-5.2-19.3z" />
    </svg>
    <svg className={styles.l2} viewBox="0 0 30 30">
      <path d="M10.5 1.7.9 7.3C0 7.7-.2 8.8.2 9.6l11.1 19.2c.5.8 1.6 1.1 2.4.6l9.6-5.5c4.1-2.4 6.4-6.7 6.4-11.1 0-2.2-.5-4.4-1.7-6.4C24.5.3 16.7-1.8 10.5 1.7z" />
    </svg>
    <svg className={styles.l3} viewBox="0 0 512 512">
      <path d="m47.6 300.4 180.7 168.7c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l180.7-168.7c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141-45.6-7.6-92 7.3-124.6 39.9l-12 12-12-12c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z" />
    </svg>
  </div>
);
